import { render } from "./BotoesNivelCombustivel.vue?vue&type=template&id=31d99870&scoped=true"
import script from "./BotoesNivelCombustivel.vue?vue&type=script&lang=js"
export * from "./BotoesNivelCombustivel.vue?vue&type=script&lang=js"

import "./BotoesNivelCombustivel.vue?vue&type=style&index=0&id=31d99870&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d99870"]])

export default __exports__